import React from 'react';

const FailedFlatsMessage = ({ failedFlats }) => {
  return (
    <div>
      <div>Квартиры, которые не изменились:</div>
      <div style={{ marginTop: 8 }}>
        {failedFlats.map((flat) => (
          <div key={flat.addressId}>
            {flat.flat ?? `${flat.address?.name} ${flat.address?.synonym}`}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FailedFlatsMessage;
